var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWoorriCard = function SvgWoorriCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#004B9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "woorriCard_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#007BC7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#woorriCard_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#007BC7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 15.5,
    rx: 9.8,
    ry: 9.1,
    fill: "url(#woorriCard_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.2,
    r: 6.3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 30.9,
    r: 17.5,
    fill: "#007BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "woorriCard_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -8.59444 9.25556 0 12 14.994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#00C8FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  })))));
};
export default SvgWoorriCard;